import React, { useEffect, useLayoutEffect } from "react";
import SuccessfulSubmit from "../../../components/cards/SuccessfulSubmit";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "../../../components/container/MainContainer";
import { CircleCheckBigIcon } from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getProject } from "../../../features/projectsSlice";
import Loading from "../../../components/loading/Loading";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const SuccessfulRequestSubmit = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.user.userInfo);
  const project = useSelector((state) => state.projects.selected);
  const projectLoad = useSelector((state) => state.projects.load.getProject);

  useEffect(() => {
    if (!project.id) {
      dispatch(getProject(id));
    }
  }, [project]);

  useLayoutEffect(() => {
    if (
      (id && project.id && project.stage.step_number < 3) ||
      (id && project.id && project.stage.step_number > 4)
    ) {
      return navigate("/requests/my-requests");
    }
  }, [project, user]);

  if (projectLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (projectLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      {project.id && project.stage.step_number === 4 && (
        <SuccessfulSubmit
          message={`Your Application Concept Paper has been submitted to the ${user.community} Community Council`}
          icon={CircleCheckBigIcon}
          link="/requests/my-requests"
          linkName="Go to My Requests"
        />
      )}
    </MainContainer>
  );
};

export default SuccessfulRequestSubmit;
